import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import "./LibraryEntry.css"

export const LibraryEntry = () => {
  return (
        <>
        <RoutingMenu activeScreen="libraryEntry" />
    <div className=''>

        <iframe

            src={`${config.RootUrl}/faculty/library/libraryEntry/libraryEntry.php?isIframe=true`}
            className="iframe col-md-12"
        >
        </iframe>
    </div>
    </>
  )
}
